import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import aboutimage from "../assets/images/about.png";
import "./about.css";
const About = () => {
  return (
    <>
      {/* Banner Section */}
      <div
        className="bg-dark text-white d-flex align-items-center about-banner"
        style={{ height: "400px" }}
      >
        <Container>
          <h1 className="display-4">About Us</h1>
          <p className="lead">
            Empowering Advocacy • Promoting Justice • Strengthening Legal
            Awareness
          </p>
        </Container>
      </div>

      {/* Content Section */}
      <Container className="my-5">
        <section className="about-section" id="about">
          <div className="container">
            <div className="about-wrapper">
              <div className="about-content">
                <h2 style={{ color: "#f54905ff", fontWeight: "800" }}>
                  About ICSAJ
                </h2>

                <p style={{ fontSize: "18px" }}>
                  The{" "}
                  <strong>
                    International Council of Sanatan Advocacy & Justice (ICSAJ)
                  </strong>
                  is a legal and advocacy-focused institution dedicated to
                  promoting excellence in legal practice, ethical advocacy, and
                  justice administration across India. Inspired by the timeless
                  principles of Sanatan Dharm, the Council draws upon
                  foundational values such as <strong>Dharma</strong>{" "}
                  (righteousness),
                  <strong> Nyaya</strong> (justice), <strong>Satya</strong>{" "}
                  (truth), and
                  <strong> Karuṇā</strong> (compassion). to inform and
                  strengthen contemporary legal systems and advocacy practices
                </p>

                <p style={{ fontSize: "18px" }}>
                  ICSAJ provides a collaborative platform for advocates, legal
                  professionals, scholars, and students to enhance professional
                  skills, engage in meaningful legal discourse, and contribute
                  to the development of a just, fair, and accessible justice
                  delivery system. The Council seeks to integrate ethical wisdom
                  with modern constitutional and legal frameworks, fostering
                  advocacy that is principled, responsible, and socially
                  conscious. ICSAJ remains firmly aligned with the values of
                  constitutionalism and secularism. The Council envisions a
                  legal culture where justice is not merely procedural, but
                  substantive and morally grounded, ensuring dignity, fairness,
                  and the rule of law for all.
                </p>
              </div>
              <div className="about-image">
                <img src={aboutimage} alt="Indian Advocate Professional" />
                <p
                  style={{
                    marginTop: "30px",
                    fontSize: "18px",
                    textAlign: "justify",
                  }}
                >
                  Through seminars, legal research, publications, and
                  collaborative initiatives, ICSAJ aims to promote ethical
                  standards in advocacy and encourage reflective legal practice.
                  The Council aspires to nurture a generation of legal
                  professionals who view advocacy not only as a profession, but
                  as a sacred responsibility also committed to the pursuit of
                  justice, the protection of rights, and the preservation of
                  Dharma in its most universal sense.
                </p>
              </div>
            </div>
          </div>
        </section>
      </Container>
    </>
  );
};

export default About;
